import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import withErrorHandler from '../hoc/withErrorHandler/withErrorHandler';
import axios from '../../axios-drops';
import AdminDropMenu from '../../components/UI/AdminDropMenu/AdminDropMenu';
import Aux from '../hoc/Auxiliary';
import Spinner from '../../components/UI/Spinner/Spinner';
import BackIconButton from '../../components/UI/Buttons/BackIconButton/BackIconButton';

import classes from './ArchiveConsole.css';


class archiveConsole extends Component {

    state = {
        drops: [], 
        loaded: false,
        perPage: 10,
        page: 1,
        totalPages: 0
    }

    componentDidMount() {
        const func = async () => {
            await axios.get('/drops.json')
            .then(response => {
                let archivedDrops = []
                for (let key in response.data) {
                    if (response.data[key].current === false) {
                        archivedDrops.push({
                            ...response.data[key],
                            id: key})
                    }
                }

                let totalPages = archivedDrops.length / 10

                const extraPage = (archivedDrops.length % 10 !== 0)? 1 : 0
                totalPages += extraPage
                this.setState({drops: archivedDrops.reverse(),
                                loaded: true,
                                totalPages: totalPages})
            })
        }
        func();
    }

    backButtonClickedHandler = () => {
        this.props.history.push('/admin')
    }
    
    openMenuHandler = (id) => {
        this.props.history.push({
            pathname: '/admin/focus/trd/' + id
            ,lastPage:'archive'
        })
    }


    render() {
  
        let console = <div className={classes.Spinner}><Spinner /></div>
        let consoleMenu = <div className={classes.SpinnerLower}><Spinner /></div>

        if (this.state.drops.length > 0 && this.state.loaded){
   
            consoleMenu = ( <div className={classes.DropMenu}>
                {this.state.drops.map((drop, index) => (

                    <AdminDropMenu
                        key={drop.id}
                        click={() => this.openMenuHandler(drop.id)}
                        image={drop.image}
                        name={drop.name}
                        variant={drop.variant}
                        edition={drop.edition} 
                        cost={drop.cost}
                        numberAvailable={drop.availability}
                        originallyAvailable={drop.originallyAvailable}
                        current={false}
                        archive={true}
                        type={drop.type}
                        id={drop.id}
                        />
                ))}
            </div>)
        }

        if (this.state.loaded) {
            console = (
            <div className={classes.ArchiveConsole}>
                <h1 className={classes.Title}>Drop Console - Archive </h1>
                <hr/>
                {consoleMenu}
                <BackIconButton clicked={this.backButtonClickedHandler}/>
            </div>
            )
        }

        let redirect = null

        if (!this.props.isAuth) {
            redirect = <Redirect to="/signin" />
        }


        return (
            <Aux>
                {redirect}
                {console}
            </Aux>
        )
    }


}

const mapStateToProps = (state) => {
    return {
        isAuth: state.token !== null
    }
}

export default connect(mapStateToProps)(withErrorHandler(archiveConsole, axios))


// WEBPACK FOOTER //
// ./src/containers/ArchiveConsole/ArchiveConsole.js